import { DependencyList } from 'react';

import { usePrevious, useUpdateEffect } from 'react-use';
import { isEqual, isNull } from 'lodash';

import { taxStore } from '../stores/taxStore';
import { scanIqTaxStore } from '../stores/scanIqTaxStore';
import {
  SOLUTION_TYPE,
  SolutionType,
} from '../../shared/constants/user-info/solutionType';
import { challengeTaxStore } from '../stores/challengeTaxStore';

const storeBySolution = {
  [SOLUTION_TYPE.SCAN_IQ]: scanIqTaxStore,
  [SOLUTION_TYPE.NUTRITION]: taxStore,
  [SOLUTION_TYPE.CHALLENGE]: challengeTaxStore,
} satisfies Record<SolutionType, unknown>;

// Required use observer
export const useEntityTaxUpdate = (
  solution: SolutionType,
  effect: () => void,
  deps: DependencyList = [],
) => {
  const store = storeBySolution[solution];

  const { entityTaxRate } = store;
  const prevEntityTaxRateInfo = usePrevious(entityTaxRate);

  useUpdateEffect(() => {
    const isInitial = isNull(prevEntityTaxRateInfo);
    const isReset = isNull(entityTaxRate);
    const isChanged = !isEqual(prevEntityTaxRateInfo, entityTaxRate);

    if (!isInitial && !isReset && isChanged) {
      effect();
    }
  }, [entityTaxRate, ...deps]);
};
